/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SiteCreate
 */
export interface SiteCreate {
    /**
     * 
     * @type {string}
     * @memberof SiteCreate
     */
    label: string;
}

/**
 * Check if a given object implements the SiteCreate interface.
 */
export function instanceOfSiteCreate(value: object): value is SiteCreate {
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function SiteCreateFromJSON(json: any): SiteCreate {
    return SiteCreateFromJSONTyped(json, false);
}

export function SiteCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiteCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
    };
}

export function SiteCreateToJSON(json: any): SiteCreate {
    return SiteCreateToJSONTyped(json, false);
}

export function SiteCreateToJSONTyped(value?: SiteCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
    };
}

